/* tslint:disable */
/* eslint-disable */
export enum TrendStatus {
  Positive = 'POSITIVE',
  Warning = 'WARNING',
  Critical = 'CRITICAL',
  Unknown = 'UNKNOWN'
}
